import Vue from 'vue'
import Vuex from 'vuex'
import tools from './modules/tools'
import user from './modules/user'
import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    error: null
  },
  mutations,
  actions,
  getters,
  modules: {
    tools,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js